import 'babel-polyfill'
import Vue from 'vue'
import App from './App.vue'
//import eruda from 'eruda'

import "@/assets/scss/style.scss"

Vue.config.productionTip = false

//eruda.init()

new Vue({
  render: h => h(App)
}).$mount('#app')
